import * as IBAN from 'iban'

const regexFull = /^(\+|[0]{2})([0-9]{2,3})[\- \/\\]([0-9]{2,5})[\- \/\\]([0-9- ]+)/
const regexTrimmed = /^[0]{0,1}([1-9]{1}[0-9]{1,4})[\- \/\\]([0-9- ]+)/
const regexNoSeperator = /[\- \/\\]/

const validatePhone = (phone) => {

    if (!phone) {
        //return "Bitte geben Sie eine Telefonnummer an."
        return " "
    }

    if (regexFull.test(phone)) {

    } else if (regexTrimmed.test(phone)) {

    } else if (!regexNoSeperator.test(phone)) {

        return "Vorwahl und Rufnummer mit Leertaste oder Trennzeichen eingeben."

    } else {

        return "Bitte geben Sie eine Telefonnummer im Format 0160 1456789 an."

    }

    return null

}

export const getCorrectPhoneFormat = (phone) => {

    if (regexFull.test(phone)) {

        const exec = regexFull.exec(phone)

        return `+${exec[2]}-${exec[3]}-${String(exec[4]).split(/[- ]/).join('')}`

    } else if (regexTrimmed.test(phone)) {

        const exec = regexTrimmed.exec(phone)

        return `+49-${exec[1]}-${String(exec[2]).split(/[- ]/).join('')}`

    }
}

const validateAddress = (values, useSpecialPhone = true) => {

    const errors = {}

    if (!values.salutation && values.salutation !== '') {
        //errors.salutation = "Bitte wählen Sie eine Anrede."
        errors.salutation = " "
    }

    if (!values.firstName) {
        //errors.firstName = "Bitte geben Sie einen Vornamen an."
        errors.firstName = " "
    } else if ((values.firstName && values.firstName.length < 2)) {
        errors.firstName = "Bitte gib einen gültigen Vornamen an."
    }

    if (!values.lastName) {
        //errors.lastName = "Bitte geben Sie einen Nachnamen an."
        errors.lastName = " "
    } else if ((values.lastName && values.lastName.length < 2)) {
        errors.lastName = "Bitte gib einen gültigen Nachnamen an."
    }

    const emailRegEx = /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\]\.,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i

    if (!values.emailAddress) {
        //errors.emailAddress = "Bitte geben Sie eine E-Mail-Adresse an."
        errors.emailAddress = " "
    } else if (!emailRegEx.test(values.emailAddress)) {
        errors.emailAddress = "Bitte gib eine gültige E-Mail-Adresse an."
    }

    const phoneValidationError = validatePhone(values.phone)

    if (useSpecialPhone) {

        if (phoneValidationError) {
            errors.phone = phoneValidationError
        }
    } else {

        if (!values.phone) {
            //errors.phone = " "
        } else if (phoneValidationError) {
            errors.phone = phoneValidationError
        }
    }

    if (!values.street) {
        //errors.street = "Bitte geben Sie einen Straßennamen an."
        errors.street = " "
    } else if ((values.street && values.street.length < 2)) {
        errors.street = "Bitte gib einen gültigen Straßennamen an."
    }

    if (!values.houseNumber) {
        //errors.houseNumber = "Bitte geben Sie eine Hausnummer an."
        errors.houseNumber = " "
    } else if (values.houseNumber && values.houseNumber.match(/^0*$/g)) {
        errors.houseNumber = "Bitte gib eine gültige Hausnummer an."
    }

    if (!values.zip) {
        //errors.zip = "Bitte geben Sie eine Postleitzahl an."
        errors.zip = " "
    } else if (values.zip && values.zip.match(/^0*$/g)) {
        errors.zip = "Bitte gib eine gültige Postleitzahl an."
    } else if ((values.zip && values.zip.length < 4)) {
        errors.zip = "Bitte gib eine gültige Postleitzahl an."
    }

    if (!values.city) {
        //errors.city = "Bitte geben Sie einen Ortsnamen an."
        errors.city = " "
    } else if ((values.city && values.city.length < 3)) {
        errors.city = "Bitte gib einen gültigen Ortsnamen an."
    }

    if (!values.country) {
        errors.country = "Bitte wähle ein Land."
    }

    /*if(values.recommendedAccount !== "21") {
     if(!values.company) {
     errors.company = "Bitte geben Sie einen Firmennamen an."
     }
     }*/

    return errors

}

export const validateBillingAddress = values => {

    const errors = validateAddress(values)

    /*if (!values.company) {
        errors.company = "Bitte geben Sie einen Firmennamen an."
    }*/
    return errors
}

export const validateTechnicalContact = values => {

    const errors = validateBillingAddress(values)

    return errors
}

export const validateTradePartner = values => {


    const errors = validateAddress(values)

    /*if(!values.recommendedAccount) {
     errors.recommendedAccount = "Bitte geben Sie einen Kundentyp an."
     }*/
    return errors

}

export const validateTradePartnerSimpleForm = (values, props) => {

    const errors = validateAddress(values, false)

    if (!values.company) {
        errors.company = "Bitte gib einen Firmennamen an."
    }

    if (props.optionals.indexOf('phone') === -1) {
        if (!values.phone) {
            errors.phone = "Bitte gib eine Telefonnummer an."
        } else {
            const phoneValidationError = validatePhone(values.phone);
            if (phoneValidationError) {
                errors.phone = phoneValidationError;
            }
        }
    }

    return errors

}

export const validateSepa = values => {

    let errors = {}

    const bicRegEx = /^([a-zA-Z]){4}([a-zA-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$/


    if (!values.iban) {
        errors.iban = "Bitte gib eine IBAN an."
    } else if (!IBAN.isValid(values.iban)) {
        errors.iban = "Bitte gib eine gültige IBAN an."
    }

    if (!values.bic) {
        errors.bic = "Bitte gib eine BIC an."
    } else if (!bicRegEx.test(values.bic)) {
        errors.bic = "Bitte gib eine gültige BIC an."
    }

    if (!values.accountHolder) {
        errors.accountHolder = "Bitte gib einen Kontoinhaber an."
    } else if (values.accountHolder.length < 2) {
        errors.accountHolder = "Bitte gib einen gültigen Kontoinhaber an."
    }

    return errors

}

export const validateAlternateSepa = values => {

    let errors = {}

    if (!values.accountHolder) {
        errors.accountHolder = "Bitte gib einen Kontoinhaber an."
    } else if (values.accountHolder.length < 2) {
        errors.accountHolder = "Bitte gib einen gültigen Kontoinhaber an."
    }

    if (!values.accountNumber) {
        errors.accountNumber = "Bitte gib deine Kontonummer an."
    }

    if (!values.bankAddress) {
        errors.bankAddress = "Bitte gib die Bankleitzahl deiner Bank an."
    }

    return errors

}

export const validatePhoneForm = values => {
    let errors = {}
    return errors
}

export const validateSimpleSummaryForm = (values, props) => {
    let errors = {}

    if (!values.price && !(props && props.articlePrice === 0)) {
        errors.price = " "
    }

    return errors
}

export const validateCommissionForm = (values) => {
    let errors = {};

    if (values && values.commission && ('' + values.commission).length !== 6) {
        errors.commission = 'Die Betreuer-ID besteht aus 6 Zeichen. Bitte gib eine 6-stellige Betreuer-ID an.'
    }

    return errors;
}



/** WEBPACK FOOTER **
 ** ./src/util/validate.js
 **/